module.exports = __webpack_public_path__ + "static/media/Jose_Graziano_desktop.49a9dd5e.jpg";